import ApiConstant from "./ApiContstant";
import DataService from "./DataService";
import { ResourceEquipment, ResourceLocation } from "./SearchService";

export interface Location {
  LocationId: number;
  Country: string;
  City: string;
  Site: string;
  Building: string;
  Floor: string;
  Zone: string;
}

export interface GetMapsLocation {
  Building: string;
  City: string;
  Country: string;
  Floor: string;
  FloorLevel: number;
  FloorLevelDisplay: string;
  Height: string;
  Level: string;
  LocationId: number;
  MapID: number;
  MapURL: string;
  ShowClock: number;
  HideNavigation: boolean;
  Site: string;
  StylesheetID: number;
  StylesheetURL: string;
  Width: string;
  Zone: string;
  CountryId: string | null;
}

export interface GetMapsRequest {
  mapid?: number;
}

export interface GetMapsResponse {
  Locations: GetMapsLocation[];
  AMFinish: string;
  PMStart: string;
  WorkingDay: string[];
}

export interface GetMapsEnhancedResponse extends GetMapsResponse {
  workdayStart: string;
  workdayEnd: string;
  amStart: string;
  amEnd: string;
  pmStart: string;
  pmEnd: string;
}

export interface GetMapHotspotsRequest {
  mapid: number;
  requestdate: string;
  isMobileApi: boolean;
  loginuser: string;
  bookings: boolean;
}

export interface GetMapHotspotsResponse {
  MapID: number;
  MapResources: HotspotResource[]
}

export interface HotspotResource {
    ErrCode: string;
    ErrDesc: string;
    Id: number;
    ResID: number;
    LicenseType: number;
    SpaceType: string;
    IconPath?: string;
    PosX: number;
    PosY: number;
    Hide: boolean;
    Zone: string;
    ResName: string;
    ResType: string;
    Status: number;
    IntAct: number;
    TitlEnt: number;
    Org?: string;
    OrgInitials: string;
    RingFenceBookingId?: number;
    Bookings: [],
    Actions?: [],
    Info: {
      RoomImg?: string;
      Occ: number;
      Keywords: string | string[];
      Description?: string;
      Equipment: ResourceEquipment[];
    },
    Keywords: string;
    ResTimeZone: string;
    LastUsedOrLastCleaned?: string;
    IsNotInUse: boolean;
    NextAvailableDate?: string;
    SpaceTypeName?: string;
    tooltip: boolean;
    Occ: number;
    ResourceEmail?: string;
    selected: boolean;
}

class MapsService {
  async getMaps(payload: GetMapsRequest): Promise<GetMapsEnhancedResponse> {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.GetMaps,
      payload
    );

    const data: GetMapsResponse = response?.data?.d;

    if (!data || !data.WorkingDay?.length) {
      throw new Error("Invalid maps response");
    }

    const workdayStart = data.WorkingDay[0];
    const workdayEnd = data.WorkingDay[data.WorkingDay.length - 1];

    return {
      ...data,
      workdayStart,
      workdayEnd,
      amStart: workdayStart,
      amEnd: data.AMFinish,
      pmStart: data.PMStart,
      pmEnd: workdayEnd,
    };
  }

  async getMapHotspots(payload: GetMapHotspotsRequest): Promise<GetMapHotspotsResponse> {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.GetMapHotspots,
      payload
    );

    return response?.data?.d ?? {};
  }
}

export default new MapsService();
